import React from 'react'
import { Oval } from 'react-loader-spinner'
import cs from 'classnames'
import './styles.sass'

interface SpinnerProps {
	color?: string
	height?: number
	width?: number
	text?: string
	className?: string
	align?: string
}

export default function Spinner({
	color = '#3B57F7',
	height = 36,
	width = 36,
	text,
	className,
	align = 'row',
}: SpinnerProps) {
	const cx = cs('LoadingSpinnerContainer', className, {
		'LoadingSpinnerContainer--row': align === 'row',
		'LoadingSpinnerContainer--column': align === 'column',
	})
	return (
		<div className={cx}>
			<Oval color={color} secondaryColor={color} height={height} width={width} />
			<p className='LoadingSpinnerContainer__text'>{text}</p>
		</div>
	)
}
